import { Component, OnDestroy, OnInit } from '@angular/core';
import { PrepaidCardData } from '../../models/Order';
import { AppStateService } from '../../services/app-state.service';
import { Subscription } from 'rxjs';
import { AppState } from '../../models/AppState';
import { AuthorizedApiService } from '../../services/authorized-api.service';
import { UrlHistoryService } from '../../services/url.history.service';
import { VenueConfig } from '../../models/FSConfig';
import { Router } from '@angular/router';
import {TranslateService} from "../../services/translate.service";
import {LightIconButtonComponent} from '../buttons/light-icon-button-component';
import {NgIf} from '@angular/common';
import {LoadingSpinnerComponent} from '../ui/loading-spinner-component';
import {BottomSheetService} from '../../services/bottom-sheet.service';
import {SignInComponent} from '../sign-in/sign-in.component';
import { ActionButtonComponent } from '../buttons/action-button.component';

@Component({
  selector: 'app-prepaid-card',
  standalone: true,
  templateUrl: './prepaid-card.component.html',
  imports: [
    LightIconButtonComponent,
    NgIf,
    LoadingSpinnerComponent,
    ActionButtonComponent
  ]
})
export class PrepaidCardComponent implements OnInit, OnDestroy {

  isLoading = true;
  showQRCode = false;
  prepaidData?: PrepaidCardData;
  config?: VenueConfig;
  appState?: AppState;
  private appStateSub?: Subscription;
  refillButtonTitle: string = "";
  hasCard: boolean = false;
  isLoggedIn: boolean = false;

  constructor(private appStateService: AppStateService, private api: AuthorizedApiService,
              private identity: UrlHistoryService, private router: Router,
              protected translate: TranslateService, private sheetService: BottomSheetService) { }

  ngOnInit(): void {
    this.appStateSub = this.appStateService.observeAppState().subscribe(appState => {
      this.appState = appState;
      this.config = this.appState.cfg;
      this.loadCardData();
      this.isLoggedIn = !appState.order.user_cfg.is_anon;
    });
  }

  ngOnDestroy(): void {
    if (this.appStateSub) {
      this.appStateSub.unsubscribe();
    }
  }

  private loadCardData() {
    if(this.hasCard) {
      return;
    }

    this.isLoading = true;
    this.api.fetchPrepaidData().subscribe(res => {
      this.hasCard = res.balance !== undefined && res.balance !== "";
      this.prepaidData = res;
      this.refillButtonTitle = this.getString("Fyll på med") + " " + this.prepaidData.formatted
      console.log(res);
    }, null, () => { this.isLoading = false; });
  }

  refill() {
    this.isLoading = true;
    this.api.createRefillReceipt("param_not_used").subscribe(res => {
      this.sheetService.popSheet();
      this.openReceiptPayment(res.receipt_key);
    }, null, () => { this.isLoading = false; });
  }

  verify() {
    this.sheetService.displaySignin(1);
  }

  private openReceiptPayment(receiptKey: string) {
    console.log(receiptKey);
    this.router.navigate([this.appStateService.venueId, 'livesplit', receiptKey]);
  }

  getString(s: string, pc: string = "normal") {
    return this.translate.single(s, pc);
  }

}
